import { Garment } from './garmentTypes';
import { Style } from './styleTypes';

interface CoverageFromStyle {
  isBottomDisabled: boolean;
  isTopDisabled: boolean;
}

/**
 * Filter style to get the master of each variant.
 * @param style Style.
 */
export function findStyleMasterVariants(style: Style) {
  const masters = style.variants.reduce((masters, garment) => {
    const index = masters.findIndex(m => m.variant === garment.variant);

    if (index === -1) {
      masters.push(garment);
    } else {
      // compare priorities and substitute if needed
      const master = masters[index];
      if (master.priority < garment.priority) {
        masters.splice(index, 1, garment);
      }
    }

    return masters;
  }, [] as Garment[]);

  return masters;
}

/**
 * Filter container to get all sizes for the same variant.
 * @param container The garment container.
 * @param variant The variant name.
 */
export function filterStyleVariantSizes(style: Style, variant: string) {
  const { variants } = style;

  const sizes = variants.filter(v => v.variant === variant);

  return sizes;
}

/**
 * Get style avatar coverage.
 * @param style Style.
 */
export function getStyleAvatarCoverage(style: Style): CoverageFromStyle {
  const type = style.type0;

  let isBottomDisabled = false;
  let isTopDisabled = false;

  switch (type) {
    case 'TOP':
      isTopDisabled = true;
      break;
    case 'BOTTOM':
      isBottomDisabled = true;
      break;
    case 'FULL_BODY':
      isBottomDisabled = true;
      isTopDisabled = true;
      break;
    default:
      break;
  }

  return { isBottomDisabled, isTopDisabled };
}
